import ApiService from "@/service/ApiService";
import {Vue} from "vue-property-decorator";


export default class HolidaysService extends Vue {

    private apiService: ApiService = new ApiService();

    public getHolidays(year: number = 0, state: string | null = null): any {

        year = year === 0 ? this.$moment().format('Y') : year;

        let url: string = '/http-requests/holidays/' + year;

        url += state ? '/' + state : '';

        this.apiService.get(url)
            .then((response: any) => {

                this.setMomentBusinessDaysHolidays(response.data);

            })
            .catch((error) => {
                console.error('holiday error', error, error.response);
            })

    }

    private setMomentBusinessDaysHolidays(holidays: any) {

        let holidaysDates: Array<string> = [];

        Object.keys(holidays).forEach((key: string) => {

            holidaysDates.push(holidays[key]['datum']);

        })

        let moment = this.$moment;

        moment.updateLocale('de', {
            holidays: holidaysDates,
            holidayFormat: 'YYYY-MM-DD'
        });

        Vue.use(require('vue-moment'), {moment});

    }

}